/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { hatsAppStrictHttpResponse } from '../../hats-app-strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ApiTwilioWhatsappStatuscallbackPost$Params {
      body?: {
'conversationsid'?: string;
'MessageSid'?: string;
'status'?: string;
'error_code'?: number;
}
}

export function apiTwilioWhatsappStatuscallbackPost(http: HttpClient, rootUrl: string, params?: ApiTwilioWhatsappStatuscallbackPost$Params, context?: HttpContext): Observable<hatsAppStrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiTwilioWhatsappStatuscallbackPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/x-www-form-urlencoded');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as hatsAppStrictHttpResponse<void>;
    })
  );
}

apiTwilioWhatsappStatuscallbackPost.PATH = '/api/twilio/whatsapp/statuscallback';
